<template>
  <v-card class="application-item">
    <v-toolbar color="teal darken-4" dark>
      <v-toolbar-side-icon left>{{application.application_type.acronym}}</v-toolbar-side-icon>
      <v-toolbar-title>{{application.application_type.name}}</v-toolbar-title>

      <v-spacer/>

      <v-tooltip top>
        <span slot="activator">
          {{application.sent_at | formatDate}}
        </span>
        <span>Data de envio</span>
      </v-tooltip>
    </v-toolbar>

    <v-list two-line subheader>
      <v-list-tile avatar @click="showApplication(application)">
        <v-list-tile-avatar>
          <v-icon>
            {{ personalTypeIcon }}
          </v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{application.person.name}}</v-list-tile-title>
          <v-list-tile-sub-title>
            {{ processCpfCnpj }}
          </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-tooltip left>
            <v-list-tile-action-text class="badge red" slot="activator">
              Pendente
            </v-list-tile-action-text>
            <span>Resolva as pendências desse requerimento</span>
          </v-tooltip>
        </v-list-tile-action>
      </v-list-tile>

      <v-divider/>

      <v-subheader>
        {{(countApplicationDocuments(application))}} documentos
        enviados
      </v-subheader>

      <v-list-tile @click="showApplication(application)">
        <v-list-tile-content>
          <v-chip color="white">
            <v-avatar class="red white--text" v-if="application.pending_documents">
              {{application.pending_documents.disapproved}}
            </v-avatar>
            <span>Reprovados</span>
          </v-chip>
        </v-list-tile-content>

        <v-list-tile-content>
          <v-chip color="white">
            <v-avatar class="green white--text" v-if="application.pending_documents">
              {{application.pending_documents.approved}}
            </v-avatar>
            <span>Aprovados</span>
          </v-chip>
        </v-list-tile-content>

        <v-spacer/>
        <v-spacer/>
        <v-spacer/>

        <v-list-tile-action>
          <v-btn icon ripple>
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'PendingApplication',
  props: {
    application: {
      default: {},
    },
    personalTypeIcon: {
      type: String,
      default: '',
    },
    processCpfCnpj: {
      type: String,
      default: '',
    },
  },
  methods: {
    countApplicationDocuments(application) {
      if(application.pending_documents){
        return application.pending_documents.approved +
            application.pending_documents.disapproved;
      }

      return "";
    },
    showApplication(application) {
      this.$store.dispatch('setLoadingDialog', true);
      this.$router.push(`${application.id}/visualizar`);
    },
  },
};
</script>
